// src/components/Recruiter/TokenBalance.jsx
import React from 'react';

const TokenBalance = ({ tokens }) => {
    return (
        <div className="bg-white rounded-xl shadow-md p-6">
            <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center">
                    <i className="fas fa-coins text-yellow-600 text-2xl"></i>
                </div>
                <div>
                    <h3 className="text-sm text-gray-500">Token Balance</h3>
                    <p className="text-2xl font-bold text-gradpath-dark">{tokens}</p>
                </div>
            </div>
            <p className="text-xs text-gray-400 mt-2">
                1 token = Unlock 1 candidate's full profile
            </p>
        </div>
    );
};

export default TokenBalance;